<template>
  <div style="overflow-x: hidden;background-color: white" class="whole-page">
    <NavHeader
      :status="{
        page:'produceExam',
        produce:true,
        solution:false
      }"
    />
    <div  class="main">
      <div class="second-card">
        <div class="second-back"></div>
        <div class="second-title"></div>
        <div class="second-card-2">

          <div class="second-back-1"></div>
          <div class="second-back-2"></div>
          <div class="second-back-3"></div>
          <div class="second-back-4"></div>


          <div class="card-2-card-1" style="background-image: linear-gradient(0deg, #ff748d 0%, #ff7daf 100%);">
            <div class="card-2-card-1-pic">
              <div class="card-pic-1"></div>
              <div class="card-pic-footer"></div>
              <div class="light"></div>
            </div>
            <div class="card-2-text" >
              <span class="text-title" style=" color: white;">实验资源</span>
              <div class="text-line" style="  background-image: linear-gradient(90deg,rgb(196, 57, 151) 0%,rgb(235, 0, 87) 100%)"></div>
              <span class="text-content" style=" color: white;">内容丰富、覆盖面广、真实可靠，紧贴各地理化生考纲所要求的实验资源</span>
            </div>
          </div>


          <div class="card-2-card-2" style="background-image: linear-gradient(0deg, #ffe8ce 0%, #fbb8a0 100%);">

            <div class="card-2-text-2" >
              <span class="text-title" style="margin-right: 1vw;">AI智能评分</span>
              <div class="text-line" style="  background-image: linear-gradient(90deg,rgb(245, 207, 10) 0%,rgb(247, 47, 0) 100%);margin-right: 1.5vw"></div>
              <span class="text-content" style="margin-right: 1vw;">紧扣各地中考评分细则，通过大数据分析给出科学准确的评分和解析</span>
            </div>
            <div class="card-2-card-1-pic">
              <div class="card-pic-2"></div>
              <div class="card-pic-footer"></div>
              <div class="light"></div>
            </div>
          </div>


          <div class="card-2-card-3" style="background-image: linear-gradient(0deg,#72d7cc 0%,#28cfb3 100%);">
            <div class="card-2-card-1-pic">
              <div class="card-pic-3"></div>
              <div class="card-pic-footer"></div>
              <div class="light"></div>
            </div>
            <div class="card-2-text" >
              <span class="text-title">成绩统计</span>
              <div class="text-line" style="  background-image: linear-gradient(90deg,rgb(255, 228, 95) 0%,rgb(255, 233, 78) 100%)"></div>
              <span class="text-content">学生学情数据可视化，老师根据大数据分析学生错题，从而针对性教学，为学习保驾护航</span>
            </div>
          </div>


          <div class="card-2-card-2" style="background-image: linear-gradient(0deg,#a1c4fd 0%,#96deff 100%);">
            <div class="card-2-text-2" >
              <span class="text-title" style="margin-right: 1vw;">在线监控</span>
              <div class="text-line" style="  background-image: linear-gradient(90deg,rgb(8, 170, 241) 0%,rgb(62, 106, 237) 100%);margin-right: 1.5vw"></div>
              <span class="text-content" style="margin-right: 1vw;">辅助老师教学管理学生自主练习与模拟考试，确保老师实验教学顺畅无阻</span>
            </div>
            <div class="card-2-card-1-pic">
              <div class="card-pic-4"></div>
              <div class="card-pic-footer"></div>
              <div class="light"></div>
            </div>
          </div>

          <div class="card-2-card-3" style="background-image: linear-gradient(0deg,#ffa1e4 0%,#cf94ec 100%);">
            <div class="card-2-card-1-pic">
              <div class="card-pic-5"></div>
              <div class="card-pic-footer"></div>
              <div class="light"></div>
            </div>
            <div class="card-2-text"  >
              <span class="text-title">模式选择</span>
              <div class="text-line" style="  background-image: linear-gradient(90deg,rgb(171, 60, 218) 0%,rgb(159, 63, 213) 100%)"></div>
              <span class="text-content">学习模式:学生自由选择练习实验<br/>任务模式:老师选择试题，限制时间段发放任务,学生收到任务在规定时间内完成</span>
            </div>
          </div>
        </div>
      </div>



      <div class="first-card">
        <div class="first-card-move-back"></div>
        <div class="first-card-back"></div>
        <div class="first-title"></div>
        <div class="first-content">
          <div class="content-back"></div>
          <div class="round">
            <div class="round-left-top" >

            </div>
            <div class="round-right-top">
            </div>
            <div class="round-right-bottom">
            </div>
            <div class="round-left-bottom">
            </div>
            <div class="font-1">01</div>
            <div class="font-1-text">First</div>
            <div class="font-2">02</div>
            <div class="font-2-text">Second</div>
            <div class="font-3">03</div>
            <div class="font-3-text">Third</div>
            <div class="font-4">04</div>
            <div class="font-4-text">Fourth</div>
            <div class="line-1"></div>
            <div class="line-2"></div>
            <div class="line-3"></div>
            <div class="line-4"></div>
            <div class="line-1-text">
              <div class="line-text-1">学测结合</div>
              <div class="line-text-2">自主练习模拟考核，实时在线检测学习效果</div>
            </div>
            <div class="line-2-text">
              <div class="line-text-1" style="background-color: rgb(240,203,114)">聚焦薄弱</div>
              <div class="line-text-2">人工智能加大数据，聚焦实验薄弱环节</div>
            </div>
            <div class="line-3-text">
              <div class="line-text-1" style="background-color: rgb(125,209,129)">实时反馈</div>
              <div class="line-text-2">直观地看到学生实验状态，及时处理异常</div>
            </div>
            <div class="line-4-text">
              <div class="line-text-1" style="background-color: rgb(186,131,247)">模拟真实考试</div>
              <div class="line-text-2">匹配实操考题，还原正式考试流程</div>
            </div>
            <div class="round-4">
              <div class="round-4-text">四大优势</div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-img">
        <div style="font-family: test;font-size: 1.2vw;color: white;font-weight: 100;cursor: default">让我们一起育见未来</div>
        <div class="footer-btn-group">
          <div class="footer-btn">立即试用</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import NavHeader from '@/components/NavHeader'
import Footer from '@/components/Footer'
import $ from 'jquery'
import DevicePixelRatio from "@/plugins/devicePixelRatio";
export default {
  name: 'producePhysical',
  layout:'default',
  components:{
    NavHeader,
    Footer
  },
  created() {
      new DevicePixelRatio().init();

  },
  data(){
    return{
      activeLine:'line1',
      rightFlag:0,
      leftFlag:0,
      title:'电学',
      aboveCard:2,
      openDate:'',
      timer:null,
      timer1:null,
      bottomFlag:0,
      text:'模拟真实的接线场景、还原真实器材、器材间自由连接，给实验提供更多可能性'
    }
  },
  mounted () {
  },
  beforeDestroy () {
    this.timer=null
    this.timer1=null
  },
  methods:{
    switchCaseCard(position){

      let now=new Date()


      if(now-this.openDate>500){
        console.log(1)
        if(position==='left'){
          $('.third-content-card-'+(this.aboveCard+3)%5).animate({
            width:'40vw',
            height:'23vw',
            top:'5vw',
            left:'23vw',
            zIndex:'1'
          },300)
          $('.third-content-card-'+(this.aboveCard+4)%5).animate({
            width:'40vw',
            height:'23vw',
            top:'5vw',
            left:'1vw',
            zIndex:'1'
          },300)
          $('.third-content-card-'+(this.aboveCard)%5).animate({
            width:'50vw',
            height:'28vw',
            top:'2.5vw',
            left:'2vw',
            zIndex:'10'
          },300)
          $('.third-content-card-'+(this.aboveCard+1)%5).animate({
            width:'58vw',
            height:'33vw',
            top:'0',
            left:'3vw',
            zIndex:'999'
          },300)
          $('.third-content-card-'+(this.aboveCard+2)%5).animate({
            width:'50vw',
            height:'28vw',
            top:'2.5vw',
            left:'12vw',
            zIndex:'10'
          },300)



          this.aboveCard=(this.aboveCard+1)%5
        }
        else{
          $('.third-content-card-'+(this.aboveCard+2)%5).animate({
            width:'40vw',
            height:'23vw',
            top:'5vw',
            left:'1vw',
            zIndex:'1'
          },300)
          $('.third-content-card-'+(this.aboveCard+1)%5).animate({
            width:'40vw',
            height:'23vw',
            top:'5vw',
            left:'23vw',
            zIndex:'1'
          },300)
          $('.third-content-card-'+(this.aboveCard)%5).animate({
            width:'50vw',
            height:'28vw',
            top:'2.5vw',
            left:'12vw',
            zIndex:'10'
          },300)
          $('.third-content-card-'+(this.aboveCard+4)%5).animate({

            width:'58vw',
            height:'33vw',
            top:'0',
            left:'3vw',
            zIndex:'999'
          },300)
          $('.third-content-card-'+(this.aboveCard+3)%5).animate({
            width:'50vw',
            height:'28vw',
            top:'2.5vw',
            left:'2vw',
            zIndex:'10'
          },300)


          this.aboveCard=(this.aboveCard+4)%5
        }
        this.openDate=now

      }
    },
    changeRight(text,title){
      this.title=title
      $('.'+this.activeLine).animate({
        width:'0.3vw'
      },300)
      $('.'+text).animate({
        width:'5vw'
      },300)
      this.activeLine=text

    }
  }
}
</script>

<style scoped>
*{
  transition: all .5s;
}
.header {
  position: relative;
  width: 100vw;
  height: 42vh;
}
.main{
  margin-top: 22vw;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.footer-img{
  width: 100vw;
  height: 9vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/育见未来.png");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer-btn-group{
  margin-top: 2vw;
  width: 30vw;
  height: 1.8vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.footer-btn{
  width: 6vw;
  font-weight: 100;
  font-size: 0.8vw;
  font-family: test;
  border: 1px white solid;
  color: white;
  background: transparent;
  line-height:1.8vw;
  text-align: center;
  cursor: pointer;
}
.first-card{
  width: 100vw;
  height: 54.375vw;
  margin: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}
.first-title{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/产品优势.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 16.2vw;
  height: 6.35vw;
  margin: 1vw auto 0;
}

.first-card-move-back{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/优势bg.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 49.375vw ;
  position: absolute;
  top:5vw;
}
.first-content{
  position: absolute;
  z-index: 10;
  width: 31.25vw;
  height: 31.25vw;

}
.content-back{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/四大优势.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 36vw;
  height: 36vw;
  margin: auto;
  position: absolute;
  left:32vw;
  top:12vw;
  z-index: -1;
}
.round{
  width: 28vw;
  height: 28vw;
  position: absolute;
  top:16vw;
  left:36vw;
}

.round .round-4{
  position: absolute;
  border: 2vw rgb(244,245,249) solid;
  width: 14vw;
  height: 14vw;
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%),
  linear-gradient(
    #7dd181,
    #7dd181);
  background-blend-mode: normal,
  normal;
  border-radius: 50%;
  left: 7vw;
  top: 7vw;
  line-height: 14vw;
  text-align: center;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.round-4-text{
  width: 4.5vw;
  text-align: center;
  line-height: 2vw;
  font-size: 2vw;
  color: white;
  font-family: test;
  letter-spacing: 3px;
}
.font-1{
  position: absolute;
  top:5vw;
  font-family: round;
  font-size: 2vw;
  color: rgb(94,178,247);
  left:4.5vw;
}
.font-1-text{
  position: absolute;
  top:7.5vw;
  font-family: round;
  font-size: 0.9vw;
  color: rgb(94,178,247);
  left:4.7vw;
}

.font-2{
  position: absolute;
  top:5vw;
  font-family: round;
  font-size: 2vw;
  color: rgb(247,210,131);
  right:4vw;
}
.font-2-text{
  position: absolute;
  top:7.5vw;
  font-family: round;
  font-size: 0.9vw;
  color: rgb(247,210,131);
  right:4vw;
}


.font-3{
  position: absolute;
  bottom:6.5vw;
  font-family: round;
  font-size: 2vw;
  color: rgb(125,209,129);
  left:4vw;
}
.font-3-text{
  position: absolute;
  bottom:5vw;
  font-family: round;
  font-size: 0.9vw;
  color: rgb(125,209,129);
  left:4.3vw;
}

.font-4{
  position: absolute;
  bottom:6.5vw;
  font-family: round;
  font-size: 2vw;
  color: rgb(186,131,247);
  right:4vw;
}
.font-4-text{
  position: absolute;
  bottom:5vw;
  font-family: round;
  font-size: 0.9vw;
  color: rgb(186,131,247);
  right:4vw;
}

.round-left-top{
  width: 14vw;
  height: 14vw;
  overflow: hidden;
  position: relative;
  float: left;
  z-index: 10;
  opacity: 0.4;
  border-radius: 28vw 0 0 0;
  transition: all .5s;
}

.round-left-top::after {
  content: "";
  position: absolute;
  display: block;
  width: 14vw;
  height: 14vw;
  right:10px;
  bottom:10px;
  border-radius: 28vw 0 0 0;
  background-color: rgb(94,178,247);
  z-index: 10;
}
.round-left-top:hover{
  transform: translate(-10px,-10px);
  animation: fadeIn .5s;
  -webkit-animation: fadeIn .5s;
  animation-fill-mode : forwards ;
  -webkit-animation-fill-mode : forwards ;
}
.round-right-top:hover{
  transform: translate(10px,-10px);
  animation: fadeIn .5s;
  -webkit-animation: fadeIn .5s;
  animation-fill-mode : forwards ;
  -webkit-animation-fill-mode : forwards ;
}
.round-left-bottom:hover{
  transform: translate(10px,10px);
  animation: fadeIn .5s;
  -webkit-animation: fadeIn .5s;
  animation-fill-mode : forwards ;
  -webkit-animation-fill-mode : forwards ;
}
.round-right-bottom:hover{
  transform: translate(-10px,10px);
  animation: fadeIn .5s;
  -webkit-animation: fadeIn .5s;
  animation-fill-mode : forwards ;
  -webkit-animation-fill-mode : forwards ;
}
.round-right-top{
  width: 14vw;
  height: 14vw;
  overflow: hidden;
  position: relative;
  float: left;
  opacity: 0.4;
  border-radius: 0 28vw 0 0;
  z-index: 10;
}

.round-right-top:after {
  content: "";
  position: absolute;
  display: block;
  left:10px;
  bottom:10px;
  width: 14vw;
  height: 14vw;
  border-radius: 0 28vw 0 0;
  background-color: rgb(240,203,114);
  z-index: 10;

}


.round-left-bottom{
  width: 14vw;
  height: 14vw;
  overflow: hidden;
  position: relative;
  float: right;
  opacity: 0.4;
  border-radius: 0 0 28vw 0;
  z-index: 10;
}

.round-left-bottom:after {
  content: "";
  position: absolute;
  right:2px;
  display: block;
  top:10px;
  left: 10px;
  width: 14vw;
  height: 14vw;
  border-radius: 0 0 28vw 0 ;
  background-color: rgb(186,131,247);
  z-index: 10;
}


.round-right-bottom{
  width: 14vw;
  height: 14vw;
  overflow: hidden;
  position: relative;
  float: left;
  border-radius: 0 0 0 28vw ;
  z-index: 10;
  opacity: 0.4;
}

.round-right-bottom:after {
  content: "";
  position: absolute;
  display: block;
  width: 14vw;
  height: 14vw;
  border-radius: 0 0 0 28vw ;
  background-color: rgb(125,209,129);
  z-index: 10;
  top:10px;
  right:10px;
}
.second-card{
  width: 100vw;
  height: 115vw;
  position: relative;
  background-color: rgb(249,250,255);
}

@keyframes fadeIn {
  0%{
    opacity: 0.4;

  }
  100%{
    opacity: .6;
  }
}
@-webkit-keyframes fadeIn {
  0%{
    opacity: 0.4;
  }
  100%{
    opacity: .6;
  }
}
@keyframes float1 {
  0%{
    top:7vw;
  }
  50%{
    top:8vw;
  }
  100%{
    top:7vw;
  }
}
@-webkit-keyframes float1 {
  0%{
    top:7vw;
  }
  50%{
    top:8vw;
  }
  100%{
    top:7vw;
  }
}
@keyframes float2 {
  0%{
    top:35vw;
  }
  50%{
    top:36vw;
  }
  100%{
    top:35vw;
  }
}
@-webkit-keyframes float2 {
  0%{
    top:35vw;
  }
  50%{
    top:36vw;
  }
  100%{
    top:35vw;
  }
}

@keyframes float3 {
  0%{
    bottom:0vw;
  }
  50%{
    bottom:-1vw;
  }
  100%{
    bottom:0vw;
  }
}
@-webkit-keyframes float3 {
  0%{
    bottom:0vw;
  }
  50%{
    bottom:-1vw;
  }
  100%{
    bottom:0vw;
  }
}

.line-1{
  width: 10vw;
  height: 4vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top:3vw;
  left:-6vw;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/1.1.png");
}
.line-2{
  width: 10vw;
  height: 4vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top:2.5vw;
  right:-6.5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/2.1.png");
}
.line-3{
  width: 10vw;
  height: 4vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  bottom:3vw;
  left:-6.5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/3.1.png");
}
.line-4{
  width: 10vw;
  height: 4vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  bottom:3vw;
  right:-6.5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/4.1.png");
}
.line-1-text{
  position: absolute;
  width: 10vw;
  height: 5vw;
  left:-18vw;
  top:2vw;
}
.line-2-text{
  position: absolute;
  width: 10vw;
  height: 5vw;
  right:-18vw;
  top:2vw;
}
.line-3-text{
  position: absolute;
  width: 10vw;
  height: 5vw;
  left:-18vw;
  bottom:0vw;
}
.line-4-text{
  position: absolute;
  width: 10vw;
  height: 5vw;
  right:-18vw;
  bottom:0;
}
.line-text-1{
  width: 100%;
  height: 2vw;
  background-color: rgb(94,178,247);
  color: white;
  font-size: 1vw;
  text-align: center;
  line-height: 2vw;
  font-family: test;
  letter-spacing: 2px;
}
.line-text-2{
  width: 100%;
  height: 3vw;
  color: black;
  font-size: 0.8vw;
  text-align: left;
  line-height: 1.6vw;
  font-family: test;
  letter-spacing: 0px;
  margin-left: 0.3vw;
}
.second-title{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/功能特点标题.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 16.2vw;
  height: 6.35vw;
  margin: 3vw auto 0;
}
.second-back{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/功能特点装饰.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100vw;
  height: 30.7vw;
  position: absolute;
  top:5vw;
}
.second-card-1{
  position: absolute;
  width: 60vw;
  height: 23.5vw;
  top:12vw;
  left: 20vw;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;

}
.second-card-2{
  position: absolute;
  width: 60vw;
  height: 100vw;
  top:12vw;
  left: 20vw;
  display: flex;
  flex-direction: column;
  z-index: 10;
  justify-content: space-between;
  align-items: center;
}
.second-back-1{
  position: absolute;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/椭圆7.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 2.8vw;
  height: 5vw;
  left:-20vw;
  top:30vw;
}
.second-back-2{
  position: absolute;
  animation: float1 5s infinite;
  -webkit-animation: float1 5s infinite;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/上下浮动.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 12vw;
  height: 10vw;
  left:-10vw;
  top:8vw;
}
.second-back-3{
  position: absolute;
  animation: float2 5s infinite;
  -webkit-animation: float2 5s infinite;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/上下浮动1.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 20vw;
  height: 21.5vw;
  right:-15vw;
  top:35vw;
}

.second-back-4{
  position: absolute;
  animation: float3 5s infinite;
  -webkit-animation: float3 5s infinite;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/上下浮动2.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 14.7vw;
  height: 19vw;
  left:-10vw;
  bottom:0vw;
}
.card-2-card-1{
  height: 17vw;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow: hidden;
  z-index: 999;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.card-2-text{
  width: 30vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  text-align: left;

}
.card-2-text-2{

  width: 30vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  text-align: right;
}
.text-2-number{
  font-family: round;
  font-size: 1.5vw;
  font-weight: bold;
  font-stretch: normal;
  margin-top: 5px;
  line-height: 2vw;
  letter-spacing: 3px;
  color: #9ec1ff;
}
.text-2-title{
  font-family: test;
  height: 2vw;
  font-size: 1.4vw;
  font-weight: 500;
  display: inline-block;
  margin-left: 1vw;
  font-stretch: normal;
  line-height: 2vw;
  letter-spacing: 3px;
  color: #3e3a39;
}
.text-2-content{
  font-family: test;
  display: inline-block;
  margin-left: 2vw;
  font-size: 0.95vw;
  font-weight: 100;
  line-height: 2vw;
  letter-spacing: 1px;
  color: #3e3a39;
  width: 20vw;
  text-align: right;
  height: 4vw;

}

.text-number{
  font-family: round;
  font-size: 1.5vw;
  font-weight: bold;
  font-stretch: normal;
  line-height: 3vw;
  letter-spacing: 3px;
  color: #9ec1ff;
}
.text-title{
  font-family: test;
  cursor: default;
  font-size: 1.4vw;
  font-weight: 800;
  display: inline-block;
  margin-left: 1vw;
  font-stretch: normal;
  line-height: 3vw;
  letter-spacing: 3px;
  color: white;
}
.text-content{
  width: 20vw;
  font-family: test;
  display: inline-block;
  margin-left: 0.8vw;
  font-size: 0.95vw;
  font-weight: 100;
  line-height: 2vw;
  letter-spacing: 1px;
  color: white;
}
.card-2-card-1-pic{
  transition: all .3s;
  overflow: hidden;
  width: 30vw;
  height: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.card-2-card-1-pic:hover .light{
  opacity: 1;
}
.card-pic-1{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/标准的试题资源.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 12vw;
  height: 10.7vw;
  position: absolute;
  z-index: 999;
  top:2vw;
}
.card-pic-footer{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/功能特点底盘.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  width: 12vw;
  height: 6.5vw;
  z-index: 10;
  top:8vw;
}
.pic-1{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/模考banner.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 30vw;
  height: 100%;
}
.card-2-card-2{
  height: 17vw;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow: hidden;
  z-index: 999;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.card-2-card-3{
  height: 17vw;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow: hidden;
  z-index: 999;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.card-1-card-1{
  width: 12vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.card-1-card-2{
  width: 12vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.card-card-card{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card-card-card-1{
  width: 12vw;
  height: 12vw;
  position: relative;
  overflow: hidden;
}
.card-card-card-1:hover .light{

  animation: lightIn 2s ;
  animation-fill-mode: forwards;
  -webkit-animation: lightIn 2s ;
  -webkit-animation-fill-mode: forwards;
}
@keyframes lightIn {
  0%{
    opacity: 0;
    top:11vw
  }
  100%{
    opacity: 1;
    top:0
  }
}
@-webkit-keyframes lightIn {
  0%{
    opacity: 0;
    top:11vw
  }
  100%{
    opacity: 1;
    top:0
  }
}


.light{
  transition: all .5s;
  position: absolute;
  top:2.5vw;
  z-index: 10;
  opacity: 0;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/光.png");
  width: 12vw;
  height: 10vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.card-pic-2{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/智能评分系统.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 12vw;
  height: 10.7vw;
  position: absolute;
  z-index: 999;
}
.card-pic-3{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/成绩统计与管理.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 12vw;
  height: 10.7vw;
  position: absolute;
  z-index: 999;
}
.card-pic-4{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/实时在线监控.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 12vw;
  height: 10.7vw;
  position: absolute;
  z-index: 999;
}
.card-pic-5{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/支持多种模式.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 12vw;
  height: 10.7vw;
  position: absolute;
  z-index: 999;
}
.card-text{
  white-space: nowrap;
  font-family: test;
  font-size: 1vw;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #3e3a39;
}
.text-line{

  width: 3vw;
  height: 3px;
  margin-left: 1vw;
}
.whole-page{

}
</style>
